import BaseCrudRepository from '@/repositories/BaseCrudRepository';
import Row from '@/repositories/data/content/row/Row';
import HttpClient from '@/util/http/HttpClient';

export default class RowRepository extends BaseCrudRepository<number, Row, Row> {
    constructor(client: HttpClient) {
        super(client, 'rest/admin/row/');
    }

    protected processBeforeCreate(user: Row): Row {
        user.order = -1;
        return user;
    }
}
